<template>
  <single-panel-page>
    <div v-show="inProgress">
      <p>We are now activating your account ...</p>
      <loader />
    </div>

    <div v-show="!inProgress && activationDone" class="animated fadeIn">
      <p class="text-success">
        Congrats! You have successfully activated your account.
      </p>
      <loader />
    </div>

    <div v-show="!inProgress && !activationDone" class="animated fadeIn">
      <p v-show="userAlreadyActive" class="text-info">
        This account is already active.
      </p>
      <router-link
        v-show="userAlreadyActive"
        :to="{ name: 'login' }"
        class="btn btn-primary"
      >
        Click to login
      </router-link>
      <p v-show="!userAlreadyActive" class="text-warning">
        There was an error during account activation. Please
        <a href="mailto:support@vestbee.com">contact us</a>
        if this repeats.
      </p>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { sleep } from '@/utils'
import * as Sentry from '@sentry/browser'

export default {
  data() {
    return {
      inProgress: true,
      activationDone: false,
      userAlreadyActive: false,
    }
  },
  async created() {
    console.log(' => params:', this.$route.params)

    const params = this.$route.params
    const request = Auth.activate({
      userId: params.userId,
      activationToken: params.activationToken,
    })
    await sleep(1000)
    try {
      const response = await request
      this.activationDone = true
      this.inProgress = false
      Auth.storeToken(response.data.token)
      await this.scheduleRedirect()
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      this.activationDone = false
      this.inProgress = false
      if (
        error.response &&
        error.response.data &&
        error.response.data.token &&
        error.response.data.token[0] === 'User is already active'
      ) {
        this.userAlreadyActive = true
      }
    }
  },
  methods: {
    async scheduleRedirect() {
      const self = this
      const interval = setInterval(countdown, 1000)
      const userRequest = this.$store.dispatch('user/getUser')
      let secondsLeft = 3

      async function countdown() {
        secondsLeft -= 1
        if (secondsLeft === 0) {
          clearInterval(interval)
          await userRequest
          self.$store.dispatch('user/goToDefaultPage')
        }
      }
    },
  },
}
</script>
